import { useCallback, useState } from 'react';
import type { FormData } from '../../types';

export function useFormState(initialData?: FormData | null) {
  const [form, setForm] = useState<FormData>(() => {
    if (initialData) return initialData;
    return {
      userName: 'Guest',
      departure: '',
      destination: '',
      startDate: '',
      endDate: '',
      adults: '',
      children: '',
      budget: '',
      interests: [],
      requirements: '',
    };
  });

  const updateField = useCallback((field: keyof FormData, value: unknown) => {
    setForm(prev => ({ ...prev, [field]: value }));
  }, []);

  return { form, setForm, updateField };
}
